import React, {
  useEffect,
  useRef,
  useState,
  useContext,
  useImperativeHandle,
  forwardRef
} from "react";
import { useTranslation } from "@/langs/useTranslation";
import { Table } from "antd";
import { Button } from "@material-ui/core";
import _ from "lodash";
import dayjs from "dayjs";
import { LanguageContext } from "@/langs/LanguageContext";
import HasPermission from "@/components/commons/HasPermission";
import { useAntdColumnResize } from "react-antd-column-resize";

const DeviceTableList = (
  {
    selectedRowKeys,
    tableLoading,
    pageSetting = {
      page: 0,
      page_size: 20,
      total: 0,
      order_by_column: null, // 排序相关
      order_by_desc: null
    },
    checkedAll,
    tableData,
    tableFunc
  },
  ref
) => {
  // 通过ref 暴露给父组件
  useImperativeHandle(ref, () => ({
    // 暴露给父组件的方法定义
    reload: () => {}
  }));
  // console.log("--------selectedRowKeys------",selectedRowKeys)
  const contextValue = useContext(LanguageContext);
  // table ref
  const tableRef = useRef(null);
  // 多语言
  const storeLang = useTranslation("store");
  // 使用的列数据
  const [columns, setColumns] = useState([]);

  // 获取当前数据库中存储的字段顺序值
  const getTableColumn = async () => {
    const defaultColumns = [
      {
        title: `${storeLang.t({ defaultMessage: "设备SN" })}`,
        visible: true,
        dataIndex: "device_sn",
        key: "device_sn",
        width: 150,
        align: "left",
        sortOrder:
          pageSetting.order_by_column === "device_sn"
            ? pageSetting.order_by_desc
            : "",
        sorter: (a, b) => false,
        ellipsis: true
      },
      {
        title: `${storeLang.t({ defaultMessage: "设备名称" })}`,
        visible: true,
        dataIndex: "device_name",
        key: "device_name",
        width: 150,
        align: "left",
        sortOrder:
          pageSetting.order_by_column === "device_name"
            ? pageSetting.order_by_desc
            : "",
        sorter: (a, b) => false,
        ellipsis: true
      },
      {
        title: `${storeLang.t({ defaultMessage: "状态" })}`,
        visible: true,
        dataIndex: "status",
        key: "status",
        align: "left",
        width: 120,
        render: (text, record) => {
          const statusOption = {
            inactive: storeLang.t({ defaultMessage: "未激活" }),
            activated: storeLang.t({ defaultMessage: "已激活" }),
            registered: storeLang.t({ defaultMessage: "已注册" })
          };
          return (
            <span className={`status status-${record.status}`}>{`${
              statusOption[record.status]
            }`}</span>
          );
        }
      },
      {
        title: `${storeLang.t({ defaultMessage: "设备类型" })}`,
        visible: true,
        dataIndex: "os_type",
        key: "os_type",
        width: 120,
        align: "left",
        ellipsis: true
      },
      {
        title: `${storeLang.t({ defaultMessage: "公司" })}`,
        visible: true,
        dataIndex: "company_name",
        key: "company_name",
        width: 120,
        align: "left",
        ellipsis: true,
        render: (text, record) => {
          const companyRes = JSON.parse(record.companies);
          const nameArr = _.map(companyRes, item => {
            return item.name;
          });
          return nameArr.join(",");
        }
      },
      {
        title: `${storeLang.t({ defaultMessage: "门店" })}`,
        visible: true,
        dataIndex: "company_groups",
        key: "company_groups",
        width: 120,
        align: "left",
        ellipsis: true
      },
      {
        title: `${storeLang.t({ defaultMessage: "标签" })}`,
        visible: true,
        dataIndex: "company_tags",
        key: "company_tags",
        width: 120,
        align: "left",
        ellipsis: true
      },
      // {
      //   title: `${storeLang.t({ defaultMessage: "Nubis版本" })}`,
      //   visible: true,
      //   dataIndex: "nubis_version",
      //   key: "nubis_version",
      //   width: 130,
      //   align: "left",
      //   ellipsis: true
      // },
      {
        title: `${storeLang.t({ defaultMessage: "注册时间" })}`,
        visible: true,
        dataIndex: "registered_at",
        key: "registered_at",
        width: 185,
        align: "left",
        sortOrder:
          pageSetting.order_by_column === "registered_at"
            ? pageSetting.order_by_desc
            : "",
        sorter: (a, b) => false,
        ellipsis: true,
        render: (text, record) => {
          return record.registered_at && record.registered_at.length > 0
            ? dayjs(record.registered_at).format("YYYY-MM-DD HH:mm")
            : "";
        }
      },
      {
        title: `${storeLang.t({ defaultMessage: "激活时间" })}`,
        visible: true,
        dataIndex: "activated_at",
        key: "activated_at",
        width: 185,
        align: "left",
        sortOrder:
          pageSetting.order_by_column === "activated_at"
            ? pageSetting.order_by_desc
            : "",
        sorter: (a, b) => false,
        ellipsis: true,
        render: (text, record) => {
          return record.activated_at && record.activated_at.length > 0
            ? dayjs(record.activated_at).format("YYYY-MM-DD HH:mm")
            : "";
        }
      },
      {
        title: `${storeLang.t({ defaultMessage: "创建时间" })}`,
        visible: true,
        dataIndex: "created_at",
        key: "created_at",
        sortOrder:
          pageSetting.order_by_column === "created_at"
            ? pageSetting.order_by_desc
            : "",
        sorter: (a, b) => false,
        width: 185,
        align: "left",
        ellipsis: true,
        render: (text, record) => {
          return record.created_at && record.created_at.length > 0
            ? dayjs(record.created_at).format("YYYY-MM-DD HH:mm")
            : "";
        }
      }
    ];
    let reloadColumns = [];
    reloadColumns = defaultColumns;
    // 操作追加到最后
    reloadColumns = reloadColumns.concat([
      {
        title: () => {
          return (
            <div className={`operation-column`}>
              <span>{storeLang.t({ defaultMessage: "操作" })}</span>
            </div>
          );
        },
        realTitle: `${storeLang.t("tableHeader.operation")}`, // 用于列自定义显示
        invisible: true, // 用于列自定义显示
        visible: true,
        key: "action",
        align: "center",
        fixed: "right",
        width: 320,
        render: (_, record) => (
          <>
            <span
              className={`operation-span`}
              onClick={() => {
                tableFunc.handleDetail(record);
              }}
            >
              {storeLang.t({ defaultMessage: "查看" })}
            </span>
            <HasPermission permission="device_and_groups_assign">
              <span
                className={`operation-span`}
                onClick={() => {
                  tableFunc.handleAssign(record);
                }}
              >
                {storeLang.t({ defaultMessage: "指派" })}
              </span>
            </HasPermission>
            <HasPermission permission="device_and_groups_register">
              <span
                className={`operation-span`}
                onClick={() => {
                  tableFunc.handleRegister(record);
                }}
              >
                {storeLang.t({ defaultMessage: "注册" })}
              </span>
            </HasPermission>
            {/* <HasPermission permission="device_and_groups_nubis_version">
              <span
                className={`operation-span`}
                onClick={() => {
                  tableFunc.handleEditVersion(record);
                }}
              >
                {storeLang.t({ defaultMessage: "修改版本" })}
              </span>
            </HasPermission> */}
            <HasPermission permission="device_and_groups_remove">
              <span
                className={`operation-span`}
                onClick={() => {
                  tableFunc.handleRemove(record);
                }}
              >
                {storeLang.t({ defaultMessage: "移除设备" })}
              </span>
            </HasPermission>
          </>
        )
      }
    ]);
    return reloadColumns;
  };

  const setTableColumn = async () => {
    // 通过云端的数据进行重新排序和收藏
    const reloadColumns = await getTableColumn();
    setColumns(_.cloneDeepWith(reloadColumns, true));
  };

  useEffect(() => {
    setTableColumn();
    // setOrderByColumn(pageSetting.order_by_column)
  }, [pageSetting, contextValue]);

  const { resizableColumns, components, tableWidth, resetColumns } =
    useAntdColumnResize(() => {
      return { columns, minWidth: 100 };
    }, [columns, tableData]);

  return (
    <>
      <Table
        ref={tableRef}
        rowKey="device_id"
        columns={resizableColumns}
        components={components}
        dataSource={tableData}
        onChange={tableFunc.onChange}
        loading={tableLoading}
        rowSelection={{
          fixed: true,
          selectedRowKeys: selectedRowKeys,
          type: "checkbox",
          onChange: tableFunc.onSelectChange,
          preserveSelectedRowKeys: true
        }}
        scroll={{ y: "200", x: tableWidth }}
        pagination={{
          current: pageSetting.page,
          pageSize: pageSetting.page_size,
          showSizeChanger: true,
          showTotal: total =>
            `${storeLang.t(
              { defaultMessage: "共{total}条" },
              { total: total }
            )}`,
          total: pageSetting.total
        }}
        footer={() => {
          return (
            <div className={`my-table-footer`}>
              {/*<Checkbox checked={checkedAll} onChange={tableFunc.handleChangeCheckedAll}>{storeLang.t({defaultMessage: '跨页全选'})}</Checkbox>*/}
              <HasPermission permission="device_and_groups_assign">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => {
                    tableFunc.handleOpenAssignModal();
                  }}
                >
                  {storeLang.t({ defaultMessage: "指派" })}
                </Button>
              </HasPermission>
              <HasPermission permission="device_and_groups_register">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => {
                    tableFunc.handleOpenRegisterModal();
                  }}
                >
                  {storeLang.t({ defaultMessage: "注册" })}
                </Button>
              </HasPermission>
              {/* <HasPermission permission="device_and_groups_nubis_version">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => {
                    tableFunc.handleOpenUpdateVersionModal();
                  }}
                >
                  {storeLang.t({ defaultMessage: "修改版本" })}
                </Button>
              </HasPermission> */}
              <HasPermission permission="device_and_groups_remove">
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => {
                    tableFunc.handleOpenRemoveModal();
                  }}
                >
                  {storeLang.t({ defaultMessage: "移除设备" })}
                </Button>
              </HasPermission>
            </div>
          );
        }}
      />
    </>
  );
};
export default React.memo(forwardRef(DeviceTableList));
